<template>
    <!--nav-->
    <nav class="">
        
    </nav>
</template>

<script>
    import Vue from "vue";
    import EventBus from '../../../event-bus';
    import SessioMixin from '../../../../mixins/sessionmixin';
    var self;
    export default {
        mixins: [SessioMixin],
        name: 'App',
        data() {
            return {
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',
                isShowLoggedinfields: true,
                showEditProfile: true,
                isLoggedIn: false,
                firstName: "",
                lastName: "",
                email: "",
                profile_image: "",
                loggedinUserId: "",
                universalSearchText: "",
                sidebarType: ""
            }
        },
        components: {
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            self.getPermissions();
        },
        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == "directory") {
                self.showEditProfile = false;
            }
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"], localStorage.getItem("profile_image"));
            }
        },
        methods: {
            universalSearchAPI: function () {
                self.$router.push("/directory/extensionslist/" + self.universalSearchText);
            }
        },
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
            if ((self.roleId != 1 && self.roleId != 0) && self.userPermissions.indexOf('add_contact_extension') <= -1) {
                openDirectLink("/");
            }
        }
    });
    EventBus.$on('logged-in', function (isLogin, fname, lname, email, profile_image) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.firstName = fname;
            self.lastName = lname;
            self.email = email;
            self.profile_image = (profile_image != '') ? profile_image : '/static/images/default.jpg';
        }
    });

    EventBus.$on('searchText', function (data) {
        self.universalSearchText = data;
    });
    EventBus.$on('sidebarType', function (data) {
        if (typeof (self) != "undefined") {
            self.sidebarType = data;
        }
    });


</script>



// WEBPACK FOOTER //
// src/components/backend/contactextension/print/Header.vue